import React, { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import Error404 from "modules/core/pages/Error404";

import { strategyPrivateRoutesConstants as routesConstants } from "./routesConstants";
import { componentLazyImport } from "modules/core/utils/helpers";

// Pages
const SingleObjective = lazy(() =>
  componentLazyImport(() => import("modules/strategy/pages/SingleObjective"))
);
const Objectives = lazy(() =>
  componentLazyImport(() => import("modules/strategy/pages/Objectives"))
);
const Decisions = lazy(() =>
  componentLazyImport(() => import("modules/strategy/pages/Decisions"))
);
const SingleDecision = lazy(() =>
  componentLazyImport(() => import("modules/strategy/pages/SingleDecision"))
);
const DecisionStatuses = lazy(() =>
  componentLazyImport(() => import("modules/strategy/pages/DecisionStatuses"))
);
const ExecDashboard = lazy(() =>
  componentLazyImport(() => import("modules/strategy/pages/ExecDashboard"))
);
const ExecReports = lazy(() =>
  componentLazyImport(() => import("modules/strategy/pages/ExecReports"))
);

const StrategyPrivateRoutes: React.FC = () => {
  return (
    <Switch>
      <Route path={routesConstants.exec_dashboard.path}>
        <ExecDashboard />
      </Route>

      <Route path={routesConstants.exec_reports.path}>
        <ExecReports />
      </Route>

      <Route path={routesConstants.single_objective.path}>
        <SingleObjective />
      </Route>

      <Route path={routesConstants.objectives.path}>
        <Objectives />
      </Route>

      <Route path={routesConstants.decision_statuses.path}>
        <DecisionStatuses />
      </Route>

      <Route path={routesConstants.single_decision.path}>
        <SingleDecision />
      </Route>

      <Route path={routesConstants.decisions.path}>
        <Decisions />
      </Route>

      <Route>
        <Error404 />
      </Route>
    </Switch>
  );
};

export default StrategyPrivateRoutes;
